import { createModule } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import { changeBodyState } from '@project/shared/utils/body-state/js/body-state';
import { getBodyState } from '@project/shared/utils/body-state/js/body-state';
import { updateNavLevel } from '@project/shared/utils/burger/js/burger';
import getCurrentBreakpoint, { onBreakpointChange } from '@project/shared/utils/breakpoints/js/breakpoints';

const classes = {
	outerParent: 'body',
	stateBurgerNav: 'state-m-burgernav--visible',
};

@createModule('Burger')
/**
 * burger module implementation.
 *
 * @author Nele Rabus <nele.rabus@namics.com>
 */
export class Burger extends TerrificSpec {
	start(resolve: Function) {
		this.initBurger(this._ctx);
		onBreakpointChange(() => this.initBurger(this._ctx));

		resolve();
	}
	stop() {}

	initBurger(ctx: HTMLElement) {
		const viewport = getCurrentBreakpoint() as string;
		if (viewport === 'small' || viewport === 'medium') {
			$(ctx)
				.off('click')
				.on('click', (ev: Event) => this.onClickBurger(ev));
			return;
		} else {
			// remove event binding for burger
			$(ctx).off('click');

			// close mobile menu if resize was done while mobile nav was open
			if (getBodyState(classes.stateBurgerNav)) {
				this.toggleNavigation();
			}
		}
	}

	/**
	 * On Click event
	 */
	onClickBurger(ev: Event) {
		ev.preventDefault();
		if (getBodyState(classes.stateBurgerNav)) {
			updateNavLevel();
			$(window).trigger('burgerClosed');
		} else {
			$(window).trigger('burgerOpened');
		}
		this.toggleNavigation();
	}

	toggleNavigation() {
		// toggle bodyclass
		changeBodyState(classes.stateBurgerNav);
	}
}
